/* eslint-disable max-len */
import EDC from '../../../shared/globals';
import { AnswerMark } from '../../../shared/mark-animation';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';
import router from '@/router';

EDC.Games.DetectiveMultipleChoice.Scenes.Main = function () {
  const gameId = router.currentRoute.params.id;
  BaseMinigamesMain.apply(this);

  this.gameConfig = store.getters['games/getGameById'](gameId).sets[0].config;
  this.gameData = EDC.Games.DetectiveMultipleChoice.GameData;
  this.difficulty = 1;
  this.iteration = 0;
  this.flashlight = null;
  this.items = [];
};

EDC.Games.DetectiveMultipleChoice.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
EDC.Games.DetectiveMultipleChoice.Scenes.Main.prototype.constructor = EDC.Games.DetectiveMultipleChoice.Scenes.Main;

const DMC = EDC.Games.DetectiveMultipleChoice.Scenes.Main.prototype;

DMC.create = function () {
  this.initialize();

  this.createTemplateUI();
  this.loadIteration();

  this.createBasicUI();
};

DMC.createTemplateUI = function () {
  const frame = this.add.sprite(this.game.config.width / 2, 100, 'title-frame').setAlpha(0.7);
  frame.displayWidth += 100;
  frame.displayHeight -= 70;
  this.add.sprite(this.game.config.width / 2, 100, 'title');
  this.add.sprite(this.game.config.width / 2, 980, 'instructions');
  this.add.sprite(1750, 580, 'detective');
  this.add.sprite(this.game.config.width / 2, 650, 'answer-frame');
};

DMC.loadIteration = function () {
  this.addItems();
};

DMC.addItems = function () {
  const { correctAnswer } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const { items } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  for (let i = 0; i < items.length; i++) {
    const container = this.add.container(450 + i * 330, 650);
    const asset = this.add.sprite(0, 0, `asset-${items[i]}`);
    container.add(asset);
    if (items[i] === correctAnswer) {
      container.isCorrect = true;
    } else {
      container.isCorrect = false;
    }
    container.setSize(220, 200);
    this.shakeAnimation(container);
    container.setInteractive();
    const markAnim = new AnswerMark(this, container).setScale(0.45);
    container.setData('markAnim', markAnim);
    this.cursorManager.setDefaultDraggableEvents(container);
    container.on('pointerup', this.checkAnswer.bind(this, container), this);
    this.items.push(container);
  }
};

DMC.checkAnswer = function (container) {
  if (container.isCorrect) {
    this.playCorrect();
    this.addFlashlight(container);
    this.items.map((x) => {
      x.disableInteractive();
      x.shakeAnim.stop();
      x.angle = 0;
      return true;
    });
    container.getData('markAnim').showMark(true, () => {});
    this.time.delayedCall(2600, this.nextIteration, [], this);
  } else {
    container.shakeAnim.stop();
    container.angle = 0;
    container.disableInteractive();
    this.playWrong();
    container.getData('markAnim').showMark(false, () => {});
  }
};

DMC.nextIteration = function () {
  this.items.map((x) => {
    x.destroy();
    return true;
  });
  this.items = [];
  this.flashlight.destroy();
  this.iteration = this.iteration + 1;
  if (!this.gameConfig.sets[this.difficulty].iterations[this.iteration]) {
    this.showSummary();
  } else {
    this.loadIteration();
  }
};

DMC.shakeAnimation = function (container) {
  container.shakeAnim = this.tweens.add({
    targets: container,
    angle: 4,
    duration: 100,
    ease: 'Linear',
    repeat: 6,
    delay: 5000,
    yoyo: true,
    onComplete: this.shakeAnimation.bind(this, container),
  });
};

DMC.addFlashlight = function (answer) {
  const container = this.add.container(answer.x, 300);
  const flashlight = this.add.sprite(0, 0, 'flashlight');
  const light = this.add.sprite(0, 520, 'light').setAlpha(0.8);
  container.add(light);
  container.add(flashlight);
  this.flashlight = container;
};

export default EDC.Games.DetectiveMultipleChoice.Scenes.Main;
